import script from "./BookingNotes.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingNotes.vue?vue&type=script&lang=ts&setup=true"

import "./BookingNotes.vue?vue&type=style&index=0&id=e33e85b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e33e85b8"]])

export default __exports__